// extracted by mini-css-extract-plugin
export default {"iconButton":"d6Y4H8rlKT_pdp","invert":"VSOo1OO63b_pdp","primary":"b0mDkJilzK_pdp","secondary":"SyRABBN_4z_pdp"};